// store.tsx

import { db } from './firestore'
import { query, where, collection, addDoc, getDocs, /*setDoc, doc,*/ } from "firebase/firestore";
import { markerData } from './interfaces';

let store = {
    state: {
        barrio: '',
        entrecalles: {
            calle1: '',
            calle2: '',
        },
        residencia: '',
        motivo: '',
        answers: {},
        markers: [],
    },
    getFirebaseDoc(pageNr: number) {
        return collection(db, `questionsPages/page_${pageNr}/questions`)
    },
    async getFirebaseCollection(collectionName: string, whereParam: any = null) {
        let q = query(collection(db, collectionName))
        console.log(whereParam)
        if (whereParam) {
            q = query(collection(db, collectionName), where(whereParam[0], whereParam[1], whereParam[2]))
        }
        const querySnapshot = await getDocs(q)
        let returnArray: any[] = []
        querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            returnArray.push(doc.data())
        });
        return returnArray
    },
    loadAll() {
        const keys = Object.keys( this.state )
        keys.forEach( ( v ) => {
            const item = localStorage.getItem( v )
            if ( item ) {
                let itemToSave = item
                try {
                    itemToSave = JSON.parse(item)
                } catch (error) {}
                const toAdd = {
                    [v]: itemToSave
                }
                this.state = {
                    ...this.state,
                    ...toAdd
                }
            }
        } )
    },
    saveAll() {
        const keys = Object.keys( this.state )
        keys.forEach( ( v, i, a ) => {
            localStorage.setItem( v, JSON.stringify( a[i] ) )
        } )
    },
    save( k: string, v: string ) {
        localStorage.setItem( k, v )
    },
    async saveEmailToFirestore(email: string|undefined) {
        let saved = false
        if (email && email !== '') {
            try {
                const newDoc = await addDoc(collection(db, "emails"), {
                    email: email,
                })
                saved = true
                console.log("Document written with ID: ", newDoc.id);
                return saved
            } catch (error) {
                console.error("Error writing document: ", error);
                return saved
            }
        }
    },
    async saveAnswerToFirestore() {
        const answer = this.state
        console.log(answer)
        try {
            const markers = this.state.markers.map( (m: any) => ({latlng: {lat: m.latlng.lat, lng: m.latlng.lng}, name: m.name }) )
            console.log(markers)
            const newDoc = await addDoc(collection(db, "answers"), {
                date: localStorage.getItem('date'),
                barrio: this.state.barrio,
                entrecalles: this.state.entrecalles,
                residencia: this.state.residencia,
                motivo: this.state.motivo,
                answers: this.state.answers,
                markers: markers
            })
            console.log("Document written with ID: ", newDoc.id);
            this.clear();
        } catch (error) {
            console.error("Error writing document: ", error);
        }
    },
    setAnswer( k: string, v: string, map: boolean = false, vextra: string = '') {
        const toAdd = {
            [k]: v
        }
        this.state.answers = {
            ...this.state.answers,
            ...toAdd
        }
        this.save( 'answers', JSON.stringify( this.state.answers ) )

        if ( map ) {
            const answersMap = JSON.parse( localStorage.getItem( 'answersMap' ) ?? '{}' )
            const toAddMap = {
                [k]: `${vextra} - ${v}`
            }
            this.save( 'answersMap', JSON.stringify( {
                ...answersMap,
                ...toAddMap
            } ) )
        }
    },
    clear () {
        localStorage.clear()
    },
    init () {
        const init = localStorage.getItem( 'date' )
        const today = new Date()
        if ( init ) {
            const lastDate = new Date( init )
            if ( ( today.valueOf() - lastDate.valueOf() ) > 86400000 ) {
                this.clear()
            } else {
                this.loadAll()
            }
        }
        localStorage.setItem( 'date', today.valueOf().toString() )

        /**
         * This part is used when loading data into firebase
         */
        // questions.map(async (b: any, index: number) => {
        //     try {
        //         const newDoc = await setDoc(doc(db, `questionsPages/page_${pageNr}/questions`, `${index+1}`), {
        //             name: b
        //         })
        //         console.log("Document written with ID: ", newDoc);
        //     } catch (error) {
        //         console.error("Error writing document: ", error);
        //     }
        // })
    },
    getAnswersMap() {
        const answersMap = JSON.parse( localStorage.getItem( 'answersMap' ) ?? '{}' )
        const keys = Object.keys( answersMap )
        let ret: string[] = []
        keys.forEach( ( v ) => {
            ret.push( answersMap[v] )
        } )
        return ret
    },
    setBarrio( barrio: string ) {
        this.state.barrio = barrio
        this.save( 'barrio', barrio )
    },
    setResidencia( residencia: string ) {
        this.state.residencia = residencia
        this.save( 'residencia', residencia )
    },
    setMotivo( motivo: string ) {
        this.state.motivo = motivo
        this.save( 'motivo', motivo )
    },
    setMarkers( markers: markerData[] ) {
        this.state.markers = (markers as never[])
        this.save( 'markers', JSON.stringify(markers) )
    },
    setCalle( name: string, calle: string ) {
        this.state.entrecalles = {...this.state.entrecalles, [name]: calle}
        this.save( 'entrecalles', JSON.stringify(this.state.entrecalles) )
    }
}

export default store